import { ReactComponent as Icon } from './icons/arrow-right.svg'

export function ArrowRightIcon(props: { className?: string; onClick?: () => void; style: {} }) {
    return <Icon style={props.style} className={`${props.className}`} onClick={props.onClick} />
}
